
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catering",
      function () {
        return require("private-next-pages/catering.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catering"])
      });
    }
  